module.exports = __webpack_public_path__ + "img/kt1.fc30f14f.png";